var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.702,15.616h-3.906l0.552-7.251h3.353c0.414,0,0.75-0.336,0.75-0.75s-0.336-0.75-0.75-0.75h-3.239l0.264-3.471 c0.031-0.413-0.278-0.773-0.691-0.805c-0.407-0.03-0.773,0.277-0.805,0.691l-0.273,3.585H8.785l0.264-3.471 c0.031-0.413-0.278-0.773-0.691-0.805C7.957,2.564,7.585,2.867,7.553,3.28L7.28,6.865H3.297c-0.414,0-0.75,0.336-0.75,0.75 s0.336,0.75,0.75,0.75h3.868l-0.552,7.251H3.297c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h3.202l-0.272,3.57 C6.196,21.1,6.505,21.46,6.918,21.491c0.02,0.001,0.039,0.002,0.058,0.002c0.388,0,0.717-0.3,0.747-0.693l0.281-3.684h7.174 l-0.272,3.57c-0.031,0.413,0.278,0.773,0.691,0.805c0.02,0.001,0.038,0.002,0.058,0.002c0.388,0,0.717-0.3,0.747-0.693l0.281-3.684 h4.02c0.414,0,0.75-0.336,0.75-0.75S21.116,15.616,20.702,15.616z M15.292,15.616H8.118l0.552-7.251h7.173L15.292,15.616z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.4636e6e6af7f2af74fc621344e2e5109.svg";
export { ForwardRef as ReactComponent };